// One chip in the detail-pane breadcrumb trail. Rendered from
// `host.selectedHistory` — each entry's shape matches the catalog
// item (`id`, `name`, etc.) plus a `_historyIndex` injected by the
// parent breadcrumb's `children` function so click handlers know
// where to truncate the stack (see `jumpToHistoryIndex`).

export const MarketplaceBreadcrumbItem = {
  tag: 'span',
  cursor: 'pointer',
  color: 'caption',
  fontSize: 'Y',
  fontWeight: '500',
  // `name ›` — the trailing chevron visually separates each chip.
  // Every chip carries one so the rightmost chevron points toward
  // the CURRENT item (which isn't itself in the breadcrumb).
  text: (el) => `${el.name || ''} ›`,
  ':hover': { color: 'blue' },

  onClick: (e, el) => {
    const host = el.call('marketplaceHostOf', el)
    el.call('jumpToHistoryIndex', host, el._historyIndex)
  }
}
